// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__2VHLJ","header":"Title_header__2PmF8","backButton":"Title_backButton__3ihIP"};